export const GET_SEARCH = 'GET_SEARCH';
export const POST_SEARCH = 'POST_SEARCH';
export const SET_SEARCH = 'SET_SEARCH';
export const ERROR_SEARCH = 'ERROR_SEARCH';